import script from "./FeishuConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./FeishuConfig.vue?vue&type=script&setup=true&lang=js"

import "./FeishuConfig.vue?vue&type=style&index=0&id=294c98a1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-294c98a1"]])

export default __exports__